module.exports = __webpack_public_path__ + "img/ev2_en.2bb82181.png";